export const SET_ERROR = 'SET_NOTIFICATION_ERROR';
export const SET_SUCCESS = 'SET_NOTIFICATION_SUCCESS';
export const SET_INFO = 'SET_NOTIFICATION_INFO';
export const CLEAR = 'CLEAR_NOTIFICATIONS';
